import { __rest } from "tslib";
import * as React from 'react';
import { css } from '@patternfly/react-styles';
export const VerticalTabsTab = (_a) => {
    var { children = null, className = '', title = null, wrapStyle = 'wrap', active = false, hasActiveDescendant = false, shown = false, onActivate = null, href, component: Component } = _a, props = __rest(_a, ["children", "className", "title", "wrapStyle", "active", "hasActiveDescendant", "shown", "onActivate", "href", "component"]);
    const classes = css('vertical-tabs-pf-tab', { active, 'active-descendant': hasActiveDescendant, shown }, className);
    const linkClasses = css({
        'no-wrap': wrapStyle === 'nowrap',
        truncate: wrapStyle === 'truncate'
    });
    const handleActivate = (e) => {
        e.preventDefault();
        if (onActivate) {
            onActivate();
        }
    };
    return (React.createElement("li", Object.assign({ className: classes }, props),
        Component ? (React.createElement(Component, { className: linkClasses })) : (React.createElement("a", { className: linkClasses, onClick: e => handleActivate(e), href: href }, title)),
        children));
};
VerticalTabsTab.displayName = 'VerticalTabsTab';
//# sourceMappingURL=VerticalTabsTab.js.map